import React from "react";

const NoBuildings = () => {
  return (
    <div className="jumbotron justify-content-center">
      <h3 className="h3 text-center text-primary">No Buildings</h3>
    </div>
  );
};

export default NoBuildings;
